module.exports = __webpack_public_path__ + "static/media/success_transaction_bg.4e4d0a4c.png";